import React from 'react';
import styled from 'styled-components';
import FeaturesList from './FeaturesList';


const StyledMobileTry = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  img {
    display: block;
    width: 100%;
    max-width: 400px;
    margin: 0 auto 16px 0;

    @media screen and (orientation: landscape) {
        display: none;
    }
  }
  
  hr {
    width: 100%;
    margin: 15px 0;
    border: none;
    border-bottom: 1px solid #E0E0E0;

    @media screen and (max-width: 1140px) and (orientation: landscape) {
       display: none;
    }
  }
`



const MobileTry = () => (
    <StyledMobileTry>
        <hr/>
        <img src='./images/try-img.png' alt='' />
        <FeaturesList/>
    </StyledMobileTry>
);

export default MobileTry;